import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { fetchAccountBillabilityAction } from "../slices/accountBillabilitySlice";

export function useAccountBillability(accountingIds: string[]) {
  const dispatch = useDispatch();
  const { billability, loading, error } = useSelector(
    (state: RootState) => state.accountBillability,
  );

  useEffect(() => {
    const unresolved = accountingIds.filter(
      (id) => id && billability[id] === undefined,
    );
    if (unresolved.length > 0) {
      dispatch(fetchAccountBillabilityAction(unresolved));
    }
  }, [accountingIds, billability, dispatch]);

  const isBillable = useCallback(
    (accountingId: string): boolean | undefined => {
      return billability[accountingId];
    },
    [billability],
  );

  return { isBillable, loading, error };
}
